function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".58",
  d: "M24 0H0v24h24V0z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M4.12 2h15.77c.6 0 1.06.52.99 1.11l-1.8 16.22c-.04.4-.33.74-.72.85l-6.08 1.74c-.18.05-.37.05-.55 0l-6.08-1.74a1.01 1.01 0 01-.72-.85L3.13 3.11A.993.993 0 014.12 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.75 18c-.07 0-.14-.01-.21-.03l-3.5-1a.75.75 0 01-.54-.72v-2c0-.41.34-.75.75-.75s.75.34.75.75v1.43l2.75.79 2.8-.8.37-3.67H8.25c-.38 0-.7-.29-.75-.67L7 6.83c-.02-.21.04-.42.19-.58A.75.75 0 017.75 6h8.5c.41 0 .75.34.75.75s-.34.75-.75.75H8.59l.33 3h6.83c.21 0 .41.09.56.25.14.16.21.37.19.58l-.5 5c-.03.31-.24.56-.54.65l-3.5 1c-.07.01-.14.02-.21.02z"
})));